module.exports = __webpack_public_path__ + "media/flags/fi-ace59fb9.svg";